import {inject, Injectable} from '@angular/core';
import {UsersService as UserApiService} from '../../api/services/users.service';
import {UserStore} from '../../stores/user.store';
import {User} from 'src/app/api/models/user';
import {firstValueFrom} from 'rxjs';
import {AuthService} from '../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private readonly userApiService = inject(UserApiService);
    private readonly userStore = inject(UserStore);
    private readonly authService = inject(AuthService);

    public async fetchUsers(): Promise<boolean> {
        this.userStore.setLoading(true);
        let status = false;
        const bearer = await this.authService.getBearer();
        try {
            const users = await firstValueFrom(this.userApiService.UsersGetAll(bearer));
            const activeUsers: Array<User> = users.filter(user => {
                return !user.isInactive && user.type !== 'System';
            });
            this.userStore.set(activeUsers);
            this.userStore.setActive(activeUsers.map(user => user.id));
            status = true;
        } catch (e) {
            console.error(e);
        } finally {
            this.userStore.setLoading(false);
        }
        return status;
    }

    public setSelectedUser(userId: string): void {
        this.userStore.update({ selected: userId });
    }

    public async getUser(userId: string): Promise<User | undefined> {
        let user: User | undefined;
        try {
            const bearer = await this.authService.getBearer();
            user = await firstValueFrom(this.userApiService.UsersGet({
                userId,
                Authorization: bearer
            }));

            this.userStore.upsert(user.id, user);
        } catch (e) {
            console.error(e);
        }
        return user;
    }
}
